<app-section-wrapper-container>
	<form
		class="um-section-parent-container"
		[formGroup]="detailsForm"
		(keypress)="onKeyPress($event)">
		<div>
			<app-input-field
				formControlName="averageEmissionsCO2"
				[isNumber]="true"
				[label]="
					'vehicles|record|emissions-section|field-label|average-emissions-co2'
				" />
			<app-single-dropdown
				formControlName="emissionsUnitCO2"
				[label]="
					'vehicles|record|emissions-section|field-label|emissions-unit-co2'
				"
				[selectOptions]="emissionsUnitCO2" />
		</div>
		<div>
			<app-input-field
				formControlName="averageFuelConsumption"
				[isNumber]="true"
				[label]="
					'vehicles|record|emissions-section|field-label|average-fuel-consumption'
				" />
			<app-single-dropdown
				formControlName="fuelConsumptionUnit"
				[label]="
					'vehicles|record|emissions-section|field-label|fuel-consumption-unit'
				"
				[selectOptions]="fuelConsumptionUnit" />
		</div>
	</form>
</app-section-wrapper-container>
